import styled from '../../../../../styles/styledComponents/themeComponents';

export const CellWithErrorMessagesStyle = styled.div`
  .error-message {
    color: #ff001f;
    margin: 0;
  }
`;
